import WalletHistoryPrice from 'components/Wallet/WalletHistoryPrice';
import placeholderA from '../../assets/placeholderA.png';
import { whiteCart } from '../../pages/dashboard/components/Icons';
import { Box, Button, Image, Text, VStack } from '@chakra-ui/react';

export default function ProductItem({ preAddToCart, item }) {
    return (
        <Box
            py="12px"
            borderRadius="8px"
            mb="2rem"
            style={{ marginBottom: '2rem' }}
            border="1.2px solid #EEEEEE">
            <Box
                margin="auto"
                w="100%"
                borderRadius="8px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                position="relative"
                cursor="pointer"
                mb="20px">
                <Image
                    src={item?.image ?? placeholderA}
                    objectFit="contain"
                    borderRadius="10px"
                    width="220px"
                />
                <Button
                    onClick={() => preAddToCart(item)}
                    pos="absolute"
                    top="-0.5rem"
                    right="0.2rem"
                    h="25px"
                    bg="#0B59D5"
                    color="white"
                    borderRadius="200px"
                    fontWeight="400"
                    fontSize="10px"
                    size="sm">
                    + {whiteCart}
                </Button>
            </Box>
            <VStack alignItems="start">
                <Text
                    color="#000"
                    lineHeight="20px"
                    mt="0"
                    textOverflow="ellipsis"
                    overflow="hidden"
                    whiteSpace="nowrap"
                    w="90%"
                    pl="12px"
                    fontSize="14px"
                    fontWeight="700"
                    title={item?.name}>
                    {item?.name}{' '}
                </Text>
                <Text color="#000" pl="12px" pb="4px" fontSize="14px" lineHeight="20px" mb="12px">
                    <WalletHistoryPrice price={item.price} />
                </Text>
            </VStack>
        </Box>
    );
}
